import {Component, forwardRef} from "@angular/core";
import {provideReportModel} from "@fedeltapointofsale/data-client";
import {StockTakeExportReportModel} from "../../reports/stock-take-export-report/stock-take-export-report.model";
import {
    SearchAction,
    SearchActionSelector
} from "../../../framework/entity/search/search-grid/actions/search-action.component";
import {ReportGenerationService} from "../../../framework/entity/report/report-generation.service";

/**
 * Search action to export a stock take
 */
@Component({
    selector: "wbo-stock-take-export-search-action",
    template: "",
    providers: [
        {
            provide: SearchActionSelector,
            useExisting: forwardRef(() => StockTakeExportSearchAction),
            multi: true
        },
        provideReportModel(StockTakeExportReportModel)
    ]
})
export class StockTakeExportSearchAction implements SearchAction {

    idColumn: string = "stockTakeId";

    constructor(private reportModel: StockTakeExportReportModel,
                private reportGenerationService: ReportGenerationService) {
    }

    /**
     *
     * @returns {number}
     */
    getImportance(): number {
        return 50;
    }

    /**
     *
     * @param data
     * @returns {string}
     */
    getIcon(data: any): string {
        return "circle-arrow-down";
    }

    getIconClass(data: any): string {
        return "";
    }

    getIconSize(data: any): number {
        return 17;
    }

    getName(data: any): string {
        return "wbo.stock-take.search.action.export";
    }

    async doAction(data: any): Promise<void> {
        this.reportModel.data[this.idColumn] = data[this.idColumn];
        await this.reportGenerationService.execute(this.reportModel);
    }

    isAvailable(data: any): boolean {
        return true;
    }
}
